<router-outlet></router-outlet>

<lib-toaster [toasts]="toastService.toasts"></lib-toaster>
